// Copyright 2025 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { CamIV64DeviceType, CamIV64DeviceTypes } from "services/Hardware/CamHTTP/CamIV64Helpers";

@autoinject
export class Webshop {
    // Use iV64s as a default device type
    protected deviceType: CamIV64DeviceType = "iV64s";
    protected isLifetime = true;

    constructor(private readonly router: Router) {
        if (this.deviceTypeFromURL) {
            this.deviceType = this.deviceTypeFromURL;
        }
    }

    /**
     * Get the device type from the URL parameters
     * @returns The CamIV64DeviceType or null if not found
     */
    private get deviceTypeFromURL(): CamIV64DeviceType | null {
        const urlParams = new URLSearchParams(window.location.search);
        const deviceType = urlParams.get("deviceType");
        if (deviceType && CamIV64DeviceTypes.includes(deviceType as CamIV64DeviceType)) {
            return deviceType as CamIV64DeviceType;
        }
        return null;
    }

    public toggleLifetime(): void {
        this.isLifetime = !this.isLifetime;
    }
}
